import type { QueryClient } from "@tanstack/react-query";
import { TeachersApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";

export async function prefetchTeacherGet(
  teacherId: number,
  queryClient: QueryClient,
  accessToken?: string,
) {
  if (!accessToken) {
    throw new Error("Access token is required for prefetching teacher");
  }

  const service = createAuthenticatedApi(TeachersApi, accessToken);

  await queryClient.prefetchQuery({
    queryKey: [QueryKeys.Teacher, teacherId],
    queryFn: () => service.getTeacherById({ id: teacherId }),
  });

  return queryClient;
}
